<div class="fx-column">
  <div class="fx-row align-items-center justify-content-between">
    <app-back></app-back>
  </div>
  <div class="fx-row align-items-center justify-content-between">
    <div class="fx-column">
      <span class="page-title">{{ title() }}</span>
      <span class="page-subtitle">{{ subtitle() }}</span>
    </div>
    <div class="fx-row align-items-center justify-content-end gap-10">
      <ng-content select="[headerActions]"></ng-content>
    </div>
  </div>
</div>
